import { useEffect, useState } from 'react';

/**
 * Measured height (px, incl. the home-indicator safe area) of the app's bottom
 * tab bar - the global `<Toolbar tabbar bottom>` shared by every tab. Returns
 * 0 when there's no tab bar.
 *
 * Used by the full-bleed floor canvas: it runs UNDER the tab bar (so a table
 * dragged down slides beneath it instead of being chopped at the seam), and
 * feeds this value as the fit's `bottomInset` so the plan still rests above
 * the bar at idle. Measured rather than hard-coded because the value depends
 * on theme (iOS/MD) and the device safe area.
 */
export function useBottomBarInset(): number {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const bar = document.querySelector('.tabbar') as HTMLElement | null;
    if (!bar) return;
    const measure = () => setInset(bar.getBoundingClientRect().height);
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(bar);
    return () => ro.disconnect();
  }, []);
  return inset;
}
